module.exports = __webpack_public_path__ + "static/the-origins-of-virtue-2343bab1713379c06bf075d8def5b9ce.jpg";